import React from 'react';
export function NavBar() {
  return <nav style={{
    padding: '16px',
    borderBottom: '1px solid #eee'
  }} data-id="element-1252">
      <a href="/" style={{
      marginRight: '20px'
    }} data-id="element-1253">
        Home
      </a>
      <a href="/blog" style={{
      marginRight: '20px'
    }} data-id="element-1254">
        Blog
      </a>
      <a href="/about" style={{
      marginRight: '20px'
    }} data-id="element-1255">
        About
      </a>
      <a href="/faq" style={{
      marginRight: '20px'
    }} data-id="element-1256">
        FAQ
      </a>
    </nav>;
}